export { BusinessPage as default } from '@/components/pages/Business'
